// extracted by mini-css-extract-plugin
module.exports = {"root":"Graph_root__1G9RQ","header":"Graph_header__3CCc7","options":"Graph_options__WUZKK"};